const { createApp } = require("vue")
const axios = require("axios")

import vSelect from "vue-select"

function mountSearch(selector) {
    const container = document.querySelector(selector)
    if (!container) return

    const initialType = container.getAttribute("data-search-type") || "empresas"

    const searchApp = createApp({
        data() {
            return {
                term: "",
                city: "",
                showDropdown: false,
                timeout: null,
                loading: false,
                subcategories: [],
                services: [], // atividades
                companies: [],
                offers: [],
                isRedirect: false,
                searchType: initialType,
            }
        },
        created() {
            let searchForm = container.querySelector(".search-form")

            document.addEventListener("click", (ev) => {
                if (searchForm && !searchForm.contains(ev.target)) {
                    this.showDropdown = false
                }
            })

            document.addEventListener("keydown", (ev) => {
                if (ev.key === "Escape") {
                    this.showDropdown = false
                    const input = container.querySelector("input")
                    if (input) input.blur()
                }
            })
        },
        methods: {
            onInputEvent($event) {
                if ($event) {
                    this.term = $event.target.value
                }

                this.debounce(() => {
                    this.showDropdown = true
                    if (!this.term) return

                    this.search()
                }, 200)
            },
            onFocus(e) {
                this.debounce(
                    () => {
                        if (
                            this.subcategories.length ||
                            this.services.length ||
                            this.companies.length ||
                            this.offers.length
                        ) {
                            this.showDropdown = true
                        }
                    },
                    this.term ? 0 : 400
                )
            },
            search() {
                if ("" == this.term) return

                this.loading = true
                console.log('[Search] API Call:', window.SEARCH_API_URL, 'Type:', this.searchType);

                axios
                    .post(window.SEARCH_API_URL, {
                        term: this.term,
                        city: this.city || "",
                        limit: 12,
                        type: this.searchType,
                    })
                    .then((success) => {
                        this.subcategories = success.data["subcategories"] || []
                        this.services = success.data["services"] || []
                        this.companies = success.data["companies"] || []
                        this.offers = success.data["offers"] || []
                    })
                    .catch((err) => {
                        console.error('[Search] Error:', err)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            searchRedirect(searchType = null) {
                if (!this.term) return
                this.isRedirect = true

                let type = searchType || this.searchType
                let url = ""

                if (type === "ofertas") {
                    url = window.SEARCH_OFFERS_URL
                } else {
                    url = window.SEARCH_COMPANIES_URL
                }

                console.log('[Search] Redirecting to:', type, 'URL:', url);

                return (document.location.href = url
                    .replace("__term", this.term)
                    .replace("__city", this.city))
            },
            debounce(callback, delay = 1000) {
                if (this.timeout) clearTimeout(this.timeout)

                this.timeout = setTimeout(callback, delay)
            },
            onSearch() {
                this.searchRedirect()
            },
        },
    })
    searchApp.component("v-select", vSelect)
    searchApp.mount(container)
}

mountSearch("#search-container")
mountSearch("#search-container-mobile")


